import React from "react";
import Icon from "../Icon";

export default (props) => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M3 9l12-6 12 6H3zm0 18h24m-12-4V13M8 23V13m14 10V13" fill="none" />
  </Icon>
);
